## 2.0.6 (2026-07-29)

- 添加浏览器存储易丢失的提醒

## 2.0.5 (2026-07-29)

- 更改数学字体为 New Computer Modern Math 以匹配官方题面样式

## 2.0.4 (2026-07-10)

- 修复打开文件时的缓存策略错误

## 2.0.3 (2026-06-20)

- 修复重新打开编辑器后预览图丢失的问题
- 项目迁移到 pnpm 包管理器

## 2.0.2 (2026-05-31)

- 为主页文档列表添加预览图

## 2.0.1 (2026-05-31)

- 修复 CSS 异常
- 在主页添加上传按钮
- 将打开文件按钮设置为主要按钮，增强引导性

## 2.0.0 (2026-05-30)

- CNOI 模板 mono 字体改为 Fira Mono，与官方保持一致
- CNOI 模板支持代码块过长自动换行
- 文件管理重构
  - 使用文件浏览器组件处理打开和另存为行为
  - 使用浏览器文件系统 API 实现直接读写磁盘上的文件（仅支持 chrome 系浏览器）
  - 主页改为最近打开的文件列表
- 现在文件需要手动保存，离开未保存的文件会有提示

在接下来的版本中，将逐渐接入一些云盘（如 OneDrive，Google Drive 等），实现跨设备同步。

## 1.0.8 (2026-04-18)

- 添加内容可能丢失的提醒

## 1.0.7 (2026-03-14)

- 支持 webp 图片
- 支持 touying 模板上传图片

## 1.0.6 (2026-03-02)

- 一些依赖的安全更新

## 1.0.5 (2026-02-20)

- 修复斜体异常的问题

## 1.0.4 (2026-02-19)

- 修复加粗和斜体异常的问题

## 1.0.3 (2026-02-19)

- 切换到 react router 框架模式，以后输出将在 `./build/client` 下
- 修改链接颜色，与 tuack 样式相同
- 修改代码块渲染效果，与 tuack 样式相同

## 1.0.2 (2026-02-03)

- 修复 changelog 日期错误
- 添加“导出为 typst 源码”功能

## 1.0.1 (2026-02-02)

- 修复相对路径引用静态文件导致无法在编辑器刷新页面的问题

## 1.0.0 (2026-02-02)

- 现在支持了添加多个模板
- 编写了一个主页，现在可以保存下来多个文件了
- 添加了 touying 模板

## 0.6.0 (2025-12-14)

- 做了个网站图标

## 0.5.3 (2025-12-08)

- 修复换行符被错误处理导致出现字符 n 的问题

## 0.5.2 (2025-12-05)

- 修复部署到线上后丢失进度条的问题

## 0.5.1 (2025-11-22)

- 添加配置页卡片拖拽排序
- 更新 safari 兼容性信息

## 0.5.0 (2025-11-20)

- 提高兼容性，目前兼容信息如下：
  - Firefox 88+
  - Google Chrome 88+
  - Microsoft Edge 88+
  - Opera 75+

## 0.4.5 (2025-11-20)

- 初步优化卡顿问题
- 在底部显示 git 提交信息

## 0.4.3 (2025-11-17)

- 修复 examples 中的拼写错误
- 将手动维护 index DB 迁移到 Dexie.js
- 优化预览区滚动性能

## 0.4.2 (2025-11-12)

- 优化 SEO。
- 添加加载失败时清理缓存的提示。

## 0.4.1 (2025-11-12)

- 修一下样例标题层级不太对的问题

## 0.4.0 (2025-11-12)

- 支持单元格合并。

## 0.3.1 (2025-11-05)

- 修复样例题面中不知道为啥没改的三级标题
- 给 readme 装饰了一下（还是很丑就是了）

## 0.3.0 (2025-11-05)

- 添加figure块
- 支持修改图片大小

## 0.2.0 (2025-11-05)

- 添加“载入样例配置”功能，查看已有的样例文件。
- 添加高级编辑开关，关闭时将隐藏目录、可执行文件、输入输出文件字段，根据题目名称自动更新。

## 0.1.0 (2025-11-03)

- 支持自动保存、导入导出正在编辑的内容。
- 为页码添加超链接。
- 为本地图片列表 UI 添加缩进。

## 0.0.2 (2025-10-30)

- 修复疏松列表的排版

## 0.0.1 (2025-10-30)

- 修复导入的图片卸载时机不对的问题。
- 添加离开页面提示内容不会被保存。
- 修复图片“复制 markdown”按钮输出不正确的问题。

## 0.0.0 (2025-10-30)

- Initial release
